import { TopBar as TopBar$1 } from './TopBar.js';
import { Actions } from './Actions.js';
import { Header } from './Header.js';
import { CustomContent } from './CustomContent.js';

var TopBar = TopBar$1;
TopBar.Actions = Actions;
TopBar.Header = Header;
TopBar.CustomContent = CustomContent;
TopBar.Actions.displayName = 'Topbar.Actions';
TopBar.Header.displayName = 'Topbar.Header';
TopBar.CustomContent.displayName = 'Topbar.CustomContent';

export { TopBar };
